import { motion } from "framer-motion";
import { WHY_MATTERS, HUMAN_CAPACITIES, IMG } from "../../data/homeContent";

export const WhyThisMatters = () => {
  return (
    <section id="why-now" data-testid="why-this-matters" className="relative py-28 md:py-40 overflow-hidden grain">
      <div className="aurora-weave" />
      <div className="absolute top-1/4 -left-40 w-[42rem] h-[42rem] glow-bronze blur-3xl pointer-events-none" />
      <div className="absolute inset-0 hex-texture opacity-40 pointer-events-none" />

      {/* Oversized faint backdrop word for drama */}
      <div className="absolute -top-6 md:top-4 left-0 right-0 text-center pointer-events-none select-none z-0">
        <span className="font-display font-black uppercase tracking-tight text-transparent leading-none"
          style={{ WebkitTextStroke: "1px rgba(201,162,75,0.10)", fontSize: "min(24vw, 20rem)" }}>
          human
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[1.15fr_0.85fr] gap-14 lg:gap-20 items-center">
        <div>
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            className="text-xs tracking-[0.32em] uppercase text-[#E7CC86]/70 mb-6">{WHY_MATTERS.eyebrow}</motion.p>
          <motion.h2 initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.05, duration: 0.7 }}
            className="font-display font-bold text-5xl sm:text-6xl lg:text-[5rem] leading-[0.98] text-cream mb-10">
            The Future Belongs to <span className="text-gold">the Deeply Human.</span>
          </motion.h2>

          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.12 }}
            className="font-serif italic text-xl md:text-2xl text-cream/80 mb-10 max-w-xl">{WHY_MATTERS.sub}</motion.p>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
            className="border-l-2 border-[#C9A24B]/55 pl-7 mb-10">
            <p className="font-serif italic text-2xl md:text-3xl text-[#E7CC86] leading-snug">{WHY_MATTERS.pull}</p>
          </motion.div>

          {WHY_MATTERS.body.map((p, i) => (
            <motion.p key={i} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.28 + i * 0.1 }}
              className="text-lg md:text-xl text-cream/72 leading-relaxed mb-5 max-w-xl">{p}</motion.p>
          ))}
        </div>

        <div className="relative">
          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.9 }}
            className="relative rounded-3xl overflow-hidden ring-gold-frame aspect-[4/5]">
            <img loading="lazy" src={IMG.mistyGold} alt="Light breaking through misted mountains" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#080B12] via-[#080B12]/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <div className="flex flex-wrap gap-x-4 gap-y-2">
                {HUMAN_CAPACITIES.map((w, i) => (
                  <motion.span key={w} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                    transition={{ delay: 0.4 + i * 0.08 }}
                    className="font-display text-xl md:text-2xl text-cream/90">{w}</motion.span>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
